// SPDX-License-Identifier: AGPL-3.0-or-later

import {validateMnemonic} from '@scure/bip39';
import {wordlist} from '@scure/bip39/wordlists/english.js';
import {mnemonicToAccount, privateKeyToAccount} from 'viem/accounts';

export type PrivyImportKind = 'private-key' | 'seed-phrase';
export function previewImportAddress(kind: PrivyImportKind, value: string): string {
	if (kind === 'private-key') {
		const normalized = value.trim().replace(/^0x/u, '');
		if (!/^[0-9a-fA-F]{64}$/u.test(normalized)) throw new Error('请输入有效的 64 位十六进制私钥。');
		try {
			return privateKeyToAccount(`0x${normalized}`).address;
		} catch {
			throw new Error('私钥数值无效，请核对原钱包备份。');
		}
	}
	const normalized = value.trim().toLowerCase().split(/\s+/u).join(' ');
	const count = normalized.split(' ').length;
	if ((count !== 12 && count !== 24) || !validateMnemonic(normalized, wordlist)) {
		throw new Error('请输入校验有效的 12 或 24 个英文助记词。');
	}
	try {
		return mnemonicToAccount(normalized).address;
	} catch {
		throw new Error('助记词无法恢复钱包，请核对原钱包备份。');
	}
}
export function normalizedImportSecret(kind: PrivyImportKind, value: string): string {
	return kind === 'private-key'
		? `0x${value.trim().replace(/^0x/u, '')}`
		: value.trim().toLowerCase().split(/\s+/u).join(' ');
}
